import {
    createContext,
    useContext,
    useEffect
} from "react";
import type {
    MenubarMenuContextType,
    MenubarContextType
} from "./type";
import {
    warnOnce
} from "../../utils/development";

export const MenubarContext = createContext<MenubarContextType | undefined>(undefined);

export const MenubarMenuContext = createContext<MenubarMenuContextType | undefined>(undefined);

export const useMenubarContext = ({
    part
}: {
    part: string;
}): MenubarContextType | undefined => {
    const context = useContext(MenubarContext);

    useEffect(() => {
        if(context) {
            return;
        }

        warnOnce({
            message: `Menubar.${part}: must be rendered inside <Menubar>.`
        });
    }, [
        context,
        part
    ]);

    return context;
};

export const useMenubarMenuContext = ({
    part
}: {
    part: string;
}): MenubarMenuContextType | undefined => {
    const context = useContext(MenubarMenuContext);

    useEffect(() => {
        if(context) {
            return;
        }

        warnOnce({
            message: `Menubar.${part}: must be rendered inside <Menubar.Menu>.`
        });
    }, [
        context,
        part
    ]);

    return context;
};
